import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { Status } from '../../../redux/constants/status';
import StatsTileRow from '../../molecules/statsTileRow/statsTileRow';
export default function DashboardStats(props) {
    var defaultData = [
        { status: Status.Loading },
        { status: Status.Loading },
        { status: Status.Loading },
    ];
    var noDataPlaceholder = [
        { status: Status.Successful },
        { status: Status.Successful },
        { status: Status.Successful },
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var data = useSelector(function (state) { return state.rootReducer.dashboardReducer.stats; });
    return (_jsx(StatsTileRow, { data: props.noData ? noDataPlaceholder : (data || defaultData) }));
}
